import { EddingGameCard } from '../../components';

export const initialGameCardState = {
  id: undefined,
  type: null,
  eng: { description: '' },
  ru: { description: '' },
  likesCount: 0,
  resultCard: undefined,
  declineResultCard: undefined,
  isVirus: false,
  isVaccine: false,
  vaccineCardId: undefined,
  answers: [],
  musicQuizTrackName: undefined,
  availabilityGroup: [],
};

const CreateGameCardPage = ({ logOut }: { logOut: () => void }) => {
  return <EddingGameCard logOut={logOut} action="add" card={initialGameCardState} />;
};

export default CreateGameCardPage;
